<div *ngFor="let toast of toasts(); trackBy: trackById"
     @toast
     class="xp-toasts__toast"
     [ngClass]="'xp-toasts__toast--' + toast.severity"
     role="alert"
     aria-live="assertive"
     aria-atomic="true"
     (mouseenter)="onPointerEnter(toast)"
     (mouseleave)="onPointerLeave(toast)">
	<div class="xp-toasts__content">
		<mat-icon class="xp-toasts__icon">{{ icon(toast) }}</mat-icon>
		<div class="xp-toasts__text">
			<div class="xp-toasts__summary">{{ toast.summary }}</div>
			<div class="xp-toasts__detail">{{ toast.detail }}</div>
		</div>
		<button type="button" class="xp-toasts__close" [attr.aria-label]="closeLabel()" (click)="onClose(toast)">
			<mat-icon class="xp-toasts__close-icon">close</mat-icon>
		</button>
	</div>
</div>
